import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Login from '../views/Login';
import Registration from '../views/Registration';
import RemindPassword from '../views/RemindPassword';
import Teams from '../views/Teams';
import View404 from '../views/View404';
import { RequireAuth, RequireNoAuth } from '../utils/enhacers';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <RequireNoAuth>
              <Login />
            </RequireNoAuth>
          }
        />
        <Route
          path="/teams/:teamId?"
          element={
            <RequireAuth>
              <Teams />
            </RequireAuth>
          }
        />
        <Route
          path="/registration"
          element={
            <RequireNoAuth>
              <Registration />
            </RequireNoAuth>
          }
        />
        <Route
          path="/remind"
          element={
            <RequireNoAuth>
              <RemindPassword />
            </RequireNoAuth>
          }
        />
        <Route path="*" element={<View404 />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
